<template>
  <div>
    <Navbar activeDirectory="admin" activePage="admin-assigned-jobs"></Navbar>
    <div class="container-fluid py-4">

      <!-- ===== PAGE HEADER ===== -->
      <div class="d-flex align-items-center justify-content-between flex-wrap mb-4" style="gap:12px;">
        <div class="d-flex align-items-center">
          <div class="cw-header-icon mr-3">
            <i class="mdi mdi-clipboard-check"></i>
          </div>
          <div class="text-left">
            <h3 class="mb-0 font-weight-bold text-dark">Lavori programmati</h3>
            <p class="mb-0 text-muted small">Gestisci e monitora lo stato dei lavori che hai creato e assegnato alle squadre</p>
          </div>
        </div>
       
      </div>

      <!-- ===== LIST CARD ===== -->
      <div class="cw-card">
        <div class="cw-section-title">
          <span class="cw-step-num">1</span>Elenco Lavori Assegnati
        </div>

        <div class="table-responsive">
          <table class="au-table">
            <thead>
              <tr>
                <th style="width: 70px;">ID</th>
                <th style="width: 80px;">Stato</th>
                <th>Tipo Intervento</th>
                <th>Ubicazione</th>
                <th>Squadra Incaricata</th>
                <th>Data Assegnazione</th>
                <th class="text-right" style="width: 110px;">Azioni</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="7" class="text-center py-4">
                  <span class="spinner-border spinner-border-sm text-primary mr-2" role="status"></span>
                  Recupero informazioni in corso...
                </td>
              </tr>
              <tr v-else-if="lavori.length === 0">
                <td colspan="7" class="text-center py-5 text-muted">
                  <i class="mdi mdi-clipboard-text-off-outline d-block mb-2" style="font-size: 2.4rem; opacity:0.3;"></i>
                  <span class="font-weight-semibold d-block text-dark">Nessun lavoro assegnato</span>
                  Non hai ancora creato o assegnato lavori alle squadre.
                </td>
              </tr>
              <tr v-for="lavoro in lavori" :key="lavoro.uuid" v-else>
                <td class="font-weight-bold text-muted">#{{ lavoro.id }}</td>
                <td class="text-center">
                  <i class="mdi mdi-checkbox-blank-circle text-primary" style="font-size:0.9rem;" v-tooltip="'Lavoro assegnato'"></i>
                </td>
                <td>
                  <span class="au-badge-soft">{{ nomeIntervento(lavoro.intervento) }}</span>
                </td>
                <td class="font-weight-semibold text-dark">{{ lavoro.strada }}</td>
                <td>
                  <div class="d-flex align-items-center">
                    <div class="au-team-avatar mr-2">
                      <i class="mdi mdi-account-group"></i>
                    </div>
                    <span class="font-weight-semibold">{{ lavoro.team.nome }}</span>
                  </div>
                </td>
                <td class="text-muted small">{{ formatDate(lavoro.avvio) || 'In attesa di avvio' }}</td>
                <td class="text-right">
                  <router-link
                    :to="{ name: 'modifica-lavoro', params: { uuid: lavoro.uuid } }"
                    class="au-btn-action"
                    v-tooltip="'Modifica'"
                  >
                    <i class="mdi mdi-pencil-outline mr-1"></i> Modifica
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";
import moment from "moment";
import { nomeIntervento } from "@/utils/intervento";

export default {
  components: {
    Navbar,
  },

  data() {
    return {
      lavori: [],
      loading: true,
      tipologia: localStorage.getItem("tipologia"),
    };
  },

  mounted() {
    if (this.tipologia !== "B" && this.tipologia !== "D") {
      this.$router.push({ name: "home" });
    } else {
      this.fetchAdminLavori();
    }
  },

  methods: {
    nomeIntervento,

    fetchAdminLavori() {
      this.loading = true;
      this.axios
        .get("dockyard/assigned_by_me")
        .then((response) => {
          this.lavori = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Errore nel recupero lavori admin:", error);
          this.loading = false;
          this.$swal.fire({
            icon: "error",
            title: "Errore",
            text: "Impossibile recuperare i lavori assegnati.",
          });
        });
    },

    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD/MM/YYYY HH:mm");
    },

    downloadLavoroPDF(lavoro) {
      if (!lavoro || !lavoro.uuid) return;
      this.$swal.fire({
        title: "Generazione PDF...",
        text: "Attendere la creazione della relazione.",
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      this.axios({
        url: `dockyard/${lavoro.uuid}/pdf`,
        method: 'GET',
        responseType: 'blob',
      })
      .then((response) => {
        this.$swal.close();
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Relazione_Lavoro_${lavoro.id || lavoro.uuid}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Errore download PDF:", error);
        this.$swal.close();
        this.$swal.fire({
          icon: "error",
          title: "Errore",
          text: "Impossibile generare la relazione in formato PDF.",
        });
      });
    },
  },
};
</script>

<style scoped>
/* =========================================
   ADMIN ASSIGNED JOBS — Premium UI (RoadME DS)
   ========================================= */

/* Header icon */
.cw-header-icon {
  width: 48px; height: 48px; border-radius: 14px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 12px rgba(247,147,30,0.35); flex-shrink: 0;
}
.cw-header-icon .mdi { color: #fff; font-size: 1.5rem; }

/* Card */
.cw-card {
  background: #fff; border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  padding: 28px; border: 1px solid rgba(0,0,0,0.05);
}

/* Section title */
.cw-section-title {
  font-size: 0.82rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: #64748b; margin-bottom: 22px;
  display: flex; align-items: center;
}
.cw-step-num {
  width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.7rem; font-weight: 800;
  display: inline-flex; align-items: center; justify-content: center;
  margin-right: 10px; flex-shrink: 0;
}

/* Submit btn (header CTA) */
.cw-btn-submit {
  display: inline-flex; align-items: center;
  padding: 10px 24px; border: none; border-radius: 30px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.88rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 14px rgba(247,147,30,0.35);
  transition: all 0.2s;
}
.cw-btn-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #E07B00, #C96A00);
  box-shadow: 0 6px 18px rgba(247,147,30,0.45); transform: translateY(-1px);
}

/* Table */
.au-table { width: 100%; border-collapse: collapse; }
.au-table thead tr { border-bottom: 2px solid #f1f5f9; }
.au-table thead th {
  padding: 10px 16px; font-size: 0.72rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em; color: #94a3b8; background: #f8fafc;
}
.au-table tbody tr { border-bottom: 1px solid #f1f5f9; transition: background 0.15s; }
.au-table tbody tr:hover { background: #f8fafc; }
.au-table td { padding: 14px 16px; vertical-align: middle; }

/* Soft badge for intervention type */
.au-badge-soft {
  display: inline-block; padding: 4px 12px; border-radius: 20px;
  font-size: 0.78rem; font-weight: 600; text-transform: capitalize;
  background: #FEF1E0; color: #C96A00; border: 1px solid #FBD9AE;
}

/* Team avatar */
.au-team-avatar {
  width: 28px; height: 28px; border-radius: 8px;
  background: #f0f9ff; color: #0284c7;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.au-team-avatar .mdi { font-size: 0.95rem; }

/* Action button (clearly visible, DS pill outline) */
.au-btn-action {
  display: inline-flex; align-items: center;
  padding: 6px 16px; border-radius: 20px; border: 1.5px solid #e2e8f0;
  background: #fff; color: #F7931E; font-size: 0.8rem; font-weight: 700;
  cursor: pointer; transition: all 0.15s; text-decoration: none;
}
.au-btn-action:hover {
  background: #FEF1E0; border-color: #F7931E; color: #E07B00; text-decoration: none;
}
</style>
